<template>
  <mia-form
    v-if="shouldRender"
    @submit="save"
  >
    <mia-form-section
      title="Vorlagen"
      description="Hier laden Sie die PDF-Dokumente hoch, die als Anhänge im Verkäuferarbeitsplatz verwendet werden."
    >
      <mia-notice
        title="Dateiformat"
        permanent
        class="mb-6"
      >
        <p class="py-0 my-0">
          Unterstützt werden PDF-Dateien mit einer PDF-Version kleiner oder gleich 1.4
        </p>
      </mia-notice>

      <mia-form-section-grid>
        <div ref="termsNewInputWrapper">
          <!-- Terms and Conditions New Cars -->
          <mia-feature-input
            label="Allgemeine Geschäftsbedingungen (Neufahrzeuge)"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsNew')"
            @change="files.termsAndConditionsNew = $event.target.files[0]; clearErrors('termsAndConditionsNew');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link term="new" />
        </div>

        <div ref="termsUsedInputWrapper">
          <!-- Terms and Conditions Used -->
          <mia-feature-input
            label="Allgemeine Geschäftsbedingungen (Gebrauchtfahrzeuge)"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsUsed')"
            @change="files.termsAndConditionsUsed = $event.target.files[0]; clearErrors('termsAndConditionsUsed');"
          />
        </div>

        <div class="mt-12">
          <mia-term-download-link term="used" />
        </div>

        <div ref="termsMediatorInputWrapper">
          <!-- Terms and Conditions Mediator -->
          <mia-feature-input
            label="Allgemeine Geschäftsbedingungen (Vermittler, Standardgeschäft)"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsMediator')"
            @change="files.termsAndConditionsMediator = $event.target.files[0]; clearErrors('termsAndConditionsMediator');"
          />
        </div>

        <div class="mt-10">
          <mia-term-download-link term="mediator" />
        </div>

        <div ref="termsMediatorAgencyInputWrapper">
          <!-- Terms and Conditions Mediator Agency -->
          <mia-feature-input
            label="Allgemeine Geschäftsbedingungen (Vermittler, Agenturgeschäft)"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsMediatorAgency')"
            @change="files.termsAndConditionsMediatorAgency = $event.target.files[0]; clearErrors('termsAndConditionsMediatorAgency');"
          />
        </div>

        <div class="mt-10">
          <mia-term-download-link term="mediator_agency" />
        </div>

        <div ref="privacySaleInputWrapper">
          <!-- Privacy Sale -->
          <mia-feature-input
            label="Datenschutzerklärung (Verkauf)"
            type="file"
            accept=".pdf"
            :errors="getErrors('privacySale')"
            @change="files.privacySale = $event.target.files[0]; clearErrors('privacySale');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            type="privacy"
            term="sale"
          />
        </div>

        <div ref="privacyMediatorInputWrapper">
          <!-- Privacy Mediator -->
          <mia-feature-input
            label="Datenschutzerklärung (Vermittlung)"
            type="file"
            accept=".pdf"
            :errors="getErrors('privacyMediator')"
            @change="files.privacyMediator = $event.target.files[0]; clearErrors('privacyMediator');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            type="privacy"
            term="mediator"
          />
        </div>

        <div ref="termsDisclaimerInputWrapper">
          <!-- Terms and Conditions Disclaimer -->
          <mia-feature-input
            label="Widerruf"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsDisclaimer')"
            @change="files.termsAndConditionsDisclaimer = $event.target.files[0]; clearErrors('termsAndConditionsDisclaimer');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            type="terms"
            term="disclaimer"
          />
        </div>

        <div ref="termsHandoverInputWrapper">
          <!-- Terms and Conditions Handover -->
          <mia-feature-input
            label="Übergabeprotokol"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsHandover')"
            @change="files.termsAndConditionsHandover = $event.target.files[0]; clearErrors('termsAndConditionsHandover');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            type="terms"
            term="handover"
          />
        </div>

        <div ref="termsHandoverDocSeatInputWrapper">
          <!-- Terms and Conditions Handover -->
          <mia-feature-input
            label="Dokumentation Übergabeprotokol Seat/Cupra"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsHandoverDocSeat')"
            @change="files.termsAndConditionsHandoverDocSeat = $event.target.files[0]; clearErrors('termsAndConditionsHandoverDocSeat');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            type="terms"
            term="handoverDocSeat"
          />
        </div>

        <div ref="termsHandoverDocSkodaInputWrapper">
          <!-- Terms and Conditions Handover -->
          <mia-feature-input
            label="Dokumentation Übergabeprotokol Skoda"
            type="file"
            accept=".pdf"
            :errors="getErrors('termsAndConditionsHandoverDocSkoda')"
            @change="files.termsAndConditionsHandoverDocSkoda = $event.target.files[0]; clearErrors('termsAndConditionsHandoverDocSkoda');"
          />
        </div>

        <div class="mt-6">
          <mia-term-download-link
            term="handoverDocSkoda"
          />
        </div>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <mia-submit-button
        :disabled="$wait.any"
        :is-loading="$wait.is('updating templates general data')"
      />
    </template>
  </mia-form>
</template>

<script>
import { updateTemplatesGeneralData } from '@/api/settings'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import TermDownloadLink from '@/components/settings/TermDownloadLink.vue'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaSettingsBasicsPublishingGeneralForm',

  components: {
    'mia-feature-input': FeatureInput,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-notice': Notice,
    'mia-submit-button': SubmitButton,
    'mia-term-download-link': TermDownloadLink
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      files: {
        termsAndConditionsNew: null,
        termsAndConditionsUsed: null,
        termsAndConditionsMediator: null,
        termsAndConditionsMediatorAgency: null,
        termsAndConditionsDisclaimer: null,
        termsAndConditionsHandover: null,
        termsAndConditionsHandoverDocSeat: null,
        termsAndConditionsHandoverDocSkoda: null,
        privacySale: null,
        privacyMediator: null
      },
      shouldRender: true
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating templates general data')

      const [error] = await updateTemplatesGeneralData({
        termsAndConditionsNew: this.files.termsAndConditionsNew,
        termsAndConditionsUsed: this.files.termsAndConditionsUsed,
        termsAndConditionsMediator: this.files.termsAndConditionsMediator,
        termsAndConditionsMediatorAgency: this.files.termsAndConditionsMediatorAgency,
        termsAndConditionsDisclaimer: this.files.termsAndConditionsDisclaimer,
        termsAndConditionsHandover: this.files.termsAndConditionsHandover,
        termsAndConditionsHandoverDocSeat: this.files.termsAndConditionsHandoverDocSeat,
        termsAndConditionsHandoverDocSkoda: this.files.termsAndConditionsHandoverDocSkoda,
        privacySale: this.files.privacySale,
        privacyMediator: this.files.privacyMediator
      })

      this.$wait.end('updating templates general data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        this.handleBackendValidationErrors(error)
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert.']
      })

      this.resetFields()

      await this.$store.dispatch('settings/loadSettings')

      this.shouldRender = false

      this.$nextTick(() => {
        this.shouldRender = true
      })
    },

    resetFields() {
      const fields = {
        termsAndConditionsNew: 'termsNewInputWrapper',
        termsAndConditionsUsed: 'termsUsedInputWrapper',
        termsAndConditionsMediator: 'termsMediatorInputWrapper',
        termsAndConditionsMediatorAgency: 'termsMediatorAgencyInputWrapper',
        termsAndConditionsDisclaimer: 'termsDisclaimerInputWrapper',
        termsAndConditionsHandover: 'termsHandoverInputWrapper',
        termsAndConditionsHandoverDocSeat: 'termsHandoverDocSeatInputWrapper',
        termsAndConditionsHandoverDocSkoda: 'termsHandoverDocSkodaInputWrapper',
        privacySale: 'privacySaleInputWrapper',
        privacyMediator: 'privacyMediatorInputWrapper'
      }

      Object.entries(fields).forEach(([field, ref]) => {
        this.$refs[ref].querySelector('input[type="file"]').value = ''
        this.$set(this.files, field, null)
      })
    }
  }
}
</script>
